import React, { PropTypes } from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import ReactTimeout from "react-timeout";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { EN } from "../../../../common/enums/languages";
import {
  getParsedErrors,
  renderErrorModal,
} from "../../../../common/form/FieldErrorHelper";
import { FAILURE, GENERATED, TEMPLATE } from "./enums/invoiceStatuses";
import { GET_LAST_VALID_TEMPLATE_INVOICE, GET_TEMPLATE_MISSING_FIELDS_FOR_CLIENT } from "../../../../../utils/data/models";
import simpleFetch from "../../../../../../utils/simpleFetch";
import { BSModal } from "../../../../common";
import BillingPeriodForm from "./BillingPeriodForm";

class TemplateInvoiceButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
    this.createTemplateInvoice = this.createTemplateInvoice.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeBillingPeriodModal = this.closeBillingPeriodModal.bind(this);
    this.handleInvoiceGenerationResult = this.handleInvoiceGenerationResult.bind(
      this
    );
    this.verifyingTemplateInvoiceGeneration = this.verifyingTemplateInvoiceGeneration.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
    this.onClick = this.onClick.bind(this);
    this.state = {
      showModal: false,
      errorsString: null,
      errorPath: "validation/clientFieldValidation/serverErrors",
      isDisabled: false,
      latestTemplateInvoice: null,
      showBillingPeriodModal: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if(!this.props.invoices || (this.props.invoices && this.props.invoices.length === 0)) {
      const { invoices } = nextProps;
      if(invoices && invoices.length > 0) {
        const latestInvoice = invoices[0];
  
        if(latestInvoice && latestInvoice["invoiceType"] === TEMPLATE.value) {
          this.setState({ latestTemplateInvoice: latestInvoice });
        }
      }
    }
  }

  verifyingTemplateInvoiceGeneration() {
    const clientId = this.props.clientId;
    this.handleDisable(true);

    simpleFetch(
      "GET",
      GET_TEMPLATE_MISSING_FIELDS_FOR_CLIENT.path.replace("{}", clientId),
      {}
    ).then((res) => {
      const isError = res && res.hasOwnProperty("missingFields") && res["missingFields"].length > 0;
      if (isError) {
        const missingFields = res["missingFields"];
        const userLanguage = localStorage.getItem("languageCode") || EN.value;
        const extraDataItem = missingFields.find(item => item.extraData);
        const extraData = extraDataItem ? extraDataItem.extraData : [];
        const otherValuesSet = new Set(missingFields.filter(item => item !== extraDataItem));
        const otherValues = Array.from(otherValuesSet);
        const serverMessage = JSON.stringify(otherValues.map(item => typeof item === 'object' ? JSON.stringify(item) : item));
        const errorCodesToString = getParsedErrors(
          serverMessage,
          userLanguage,
          this.state.errorPath,
          extraData
        );
        this.setState({ errorsString: errorCodesToString, showModal: true});        
      } else {
        this.setState({showBillingPeriodModal: true});
      }
    }
  );
  }

  handleClick() {
    this.verifyingTemplateInvoiceGeneration();
    this.handleDisable(false);

  }

  closeBillingPeriodModal() {
    this.setState({ showBillingPeriodModal: false });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  onClick() {
    const validationErrors = this.refs.billingPeriod.getWrappedInstance().submit();
    
    if (validationErrors && Object.keys(validationErrors).length) {
      return validationErrors;
    }
    this.closeBillingPeriodModal();
  }

  handleInvoiceGenerationResult(invoice) {
    const isEmpty = invoice["amount"] == 0;
    toast.dismiss();
    if (isEmpty) {
      toast(
        <FormattedMessage id="invoices.datatable.actions.templateMissingClientInfo" />,
        {
          type: toast.TYPE.WARNING,
          autoClose: false,
        }
      );
    } else {
      toast(
        <FormattedMessage id="invoices.datatable.actions.templateGenerationSuccess" />,
        {
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
        }
      );
    }
  }

  handleDisable(disableFlag) {
    this.setState({
      isDisabled: disableFlag,
    });
  }
  createTemplateInvoice(event) {
    const clientId = this.props.clientId;
    const { latestTemplateInvoice } = this.state;
    const billingPeriodId = event.billingPeriodId;
    if (clientId) {
      const data = { clientId: clientId, billingPeriodId: billingPeriodId };
      const model = {
        path: `/v1/invoices/generate-template`,
      };
      this.handleDisable(true);
      const toastId = toast(
        <span className="import-export-loader">
          <span className="loader">
            <FormattedMessage id={"common.generating"} />
          </span>
        </span>,
        { autoClose: false, closeButton: true }
      );
      this.setState({
        toastId: toastId,
      });

      /** Make call to generate template invoice */
      this.props.dataActions.simplePost({ model, data });

      /** Do the setInterval call to check for the latest valid template invoice.
       * setInterval will only be cleared when invoice has invoiceStatusType == GENERATED or FAILURE.
       */
      const interval = setInterval(() => {
        simpleFetch(
          "GET",
          GET_LAST_VALID_TEMPLATE_INVOICE.path.replace("{}", clientId), {}
        ).then((response) => {
          if (response.invoiceStatusType === GENERATED.value && response.invoiceType === TEMPLATE.value) {
            if(latestTemplateInvoice && latestTemplateInvoice.invoiceId != response.invoiceId || !latestTemplateInvoice) {
              toast.dismiss();
              this.handleInvoiceGenerationResult(response);
              this.props.updateValidity(true);

              this.props.refreshDataTable();
              this.handleDisable(false);
              clearInterval(interval);
            }
          }
          else if(response.invoiceStatusType === FAILURE.value && response.invoiceType === TEMPLATE.value) {
            if(latestTemplateInvoice && latestTemplateInvoice.invoiceId != response.invoiceId || !latestTemplateInvoice) {
              toast.dismiss();
              toast(
              <FormattedMessage id="invoices.datatable.actions.templateGenerationFailure" />,
              {
                type: toast.TYPE.ERROR,
                autoClose: false,
              }
            );
            this.props.refreshDataTable();
            this.handleDisable(false);
            clearInterval(interval);
          }
        }
        }).catch(() => {
            toast.dismiss();
              toast(
              <FormattedMessage id="validation.customMessages.serverErrors.genericError" />,
              {
                type: toast.TYPE.ERROR,
                autoClose: false,
              }
            );
            this.props.refreshDataTable();
            this.handleDisable(false);
            clearInterval(interval);
          });
      }, 3000);
    } else {
      toast(
        <FormattedMessage id="invoices.datatable.actions.templateMissingBillingPeriod" />,
        {
          type: toast.TYPE.ERROR,
          autoClose: false,
        }
      );
      this.handleDisable(false);
    }
  }
  render() {
    return (
      <div>
        <BSModal
          show={this.state.showBillingPeriodModal}
          title={
            <FormattedMessage id="invoices.form.billingPeriodModal.title"/>
          }
          closeButtonKey="common.close"
          onClose={this.closeBillingPeriodModal}
          actions={[
            {
              id: 1,
              disabled: false,
              text: <FormattedMessage id="common.confirm" />,
              action: this.onClick,
            },
          ]}
        >
          <BillingPeriodForm
            billingPeriods={this.props.billingPeriods}
            onSubmit={this.createTemplateInvoice}
            ref="billingPeriod"
          />

        </BSModal>
        <Button
          ref="action"
          className="generate-btn"
          bsStyle="primary"
          bsSize="xsmall"
          onClick={this.handleClick}
          disabled={this.state.isDisabled || this.props.isGenerating}
        >
          <FormattedMessage id="invoices.datatable.actions.templateInvoice" />
        </Button>
        {renderErrorModal(
          this.state.showModal,
          this.closeModal,
          this.state.errorsString,
          "validation.clientFieldValidation.invoiceMEVError"
        )}
      </div>
    );
  }
}
TemplateInvoiceButton.propTypes = {
  clientId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  refreshDataTable: PropTypes.func,
  dataActions: PropTypes.object,
  isGenerating: PropTypes.bool,
  updateValidity: PropTypes.func,
  currentTemplateInvoice: PropTypes.object,
  billingPeriods: PropTypes.array,
  invoices: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default ReactTimeout(
  connect(null, mapDispatchToProps)(TemplateInvoiceButton)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/TemplateInvoiceButton.js